<template>
  <div class="dashboard body">
    <el-container>
      <!-- <Aside @toggle="toggle($event)" /> -->
      <el-main>
        <button
          v-show="1 == 0"
          v-shortkey="['f10']"
          @shortkey="confirmEdit = true"
        ></button>
        <button
          v-show="1 == 0"
          v-shortkey="['f9']"
          @shortkey="saveShortKey"
        ></button>
        <el-row class="bg-White p-3" justify="space-between">
          <el-col :lg="6">
            <h3 style="margin: 0">انشاء مرتجع</h3>
          </el-col>
          <el-col :lg="10"></el-col>
          <el-col :lg="3">
            <b>رقم الفاتوره : </b>
            <b>{{ sales[0].id }}</b>
          </el-col>
          <el-col :lg="5">
            <b>اسم العميل : </b>
            <b v-if="customer">{{ customer.name }}</b>
          </el-col>
        </el-row>
        <el-table
          ref="returnInvoiceTable"
          :data="sales[selectedIndex].products"
          align="right"
          style="overflow: auto"
          border
        >
          <el-table-column align="right" width="100">
            <template slot="header">
              <el-checkbox
                id="selectAll"
                @change="checkedAllProducts"
                ref="checkAll"
                ><small>تحديد الكل</small></el-checkbox
              >
            </template>
            <template slot-scope="scope">
              <el-checkbox
                v-model="scope.row.checked"
                @change="selectProduct(scope.row)"
              />
            </template>
          </el-table-column>
          <el-table-column label="#" type="index"></el-table-column>
          <el-table-column label="المنتج" prop="name"></el-table-column>
          <el-table-column label="الوحدة" prop="pivot.unit"></el-table-column>
          <el-table-column label="الكمية">
            <template slot-scope="scope">
              {{ scope.row.pivot.qty - scope.row.pivot.returned_qty }}
            </template>
          </el-table-column>
          <el-table-column label="اضافة كمية المرتجع">
            <template slot-scope="scope">
              <el-popover
                :ref="scope.row.id + '-' + scope.row.pivot.unit_type"
                placement="left"
                trigger="manual"
                content="لا يمكن ادخال كمية زياده عن ما تم بيعه"
                v-model="scope.row.showQtyToolTip"
                class="bg-danger"
                style="
                  background-color: #f56c6c !important;
                  color: #fff !important;
                "
              >
              </el-popover>
              <input
                type="number"
                class="form-control"
                @change="calcTotal(scope.row)"
                min="0"
                :class="scope.row.showQtyToolTip ? 'error' : ''"
                @focus="$event.target.select()"
                v-model="scope.row.pivot.return_qty"
                v-popover="scope.row.id + '-' + scope.row.pivot.unit_type"
              />
            </template>
          </el-table-column>
          <el-table-column
            label="سعر البيع"
            prop="pivot.sale_price"
          ></el-table-column>
          <el-table-column label="الإجمالي">
            <template slot-scope="scope">
              {{ scope.row.pivot.sale_price * scope.row.pivot.return_qty }}
            </template>
          </el-table-column>
        </el-table>
        <el-row
          :gutter="1"
          class="footer"
          v-if="sales[selectedIndex].products.length > 0"
        >
          <el-col :lg="24" :sm="24">
            <el-row>
              <el-col :lg="18">
                <div
                  class="bg-White footer-top"
                  style="justify-content: start; padding-right: 20px"
                >
                  الملاحظات : <span>برجاء ارسال الفاتورة يوم السبت القادم</span>
                </div>
              </el-col>
              <el-col :xl="6" :lg="6" :md="8" :sm="8" style="text-align: end">
                <div class="bg-White footer-top" style="justify-content: flex-end; padding-left: 20px">
                  <el-popconfirm
                    v-if="sales[0].discount > 0"
                    confirm-button-text="تاكيد"
                    cancel-button-text="إلغاء"
                    icon="el-icon-info"
                    icon-color="red"
                    :title="
                      'سيتم خصم قيمة ' + sales[0].discount + ' من الفاتورة'
                    "
                    @confirm="confirmEdit = true"
                  >
                    <el-button slot="reference" class="save"
                      >حفظ المرتجع</el-button
                    >
                  </el-popconfirm>
                  <el-button v-else @click="confirmEdit = true" class="save"
                    >حفظ المرتجع</el-button
                  >
                  <el-popconfirm
                    confirm-button-text="موافق"
                    cancel-button-text="إلغاء"
                    icon="el-icon-info"
                    icon-color="red"
                    title="هل تريد الرجوع للتقرير؟"
                    @confirm="goTo('/sales/return')"
                  >
                    <el-button slot="reference" class="exit"
                      >الغاء</el-button
                    >
                  </el-popconfirm>
                </div>
              </el-col>
            </el-row>
          </el-col>
          <el-col :xl="4" :lg="4" :md="8" :sm="8">
            <el-row :gutter="1" style="flex-direction: column;">
              <el-col :span="24">
                <div class="bg-White alignment top">
                  <p>الكميه</p>
                  <p>
                    <span class="num">{{ sales[0].total_qty }}</span>
                  </p>
                </div>
              </el-col>
              <el-col :span="24">
                <div class="bg-White alignment">
                  <p>كمية المرتجع</p>
                  <p>
                    <span class="num">{{ reternSale.total_qty }}</span>
                  </p>
                </div>
              </el-col>
            </el-row>
          </el-col>
          <el-col :xl="4" :lg="4" :md="8" :sm="8">
            <el-row :gutter="1" style="flex-direction: column;">
              <el-col :span="24">
                <div class="bg-White alignment top">
                  <p>طريقة الدفع</p>
                  <p>
                    <span class="num">كاش</span>
                  </p>
                </div>
              </el-col>
              <el-col :span="24">
                <div class="bg-White alignment">
                  <p>موعد التوصيل</p>
                  <p><span class="num">نفس اليوم</span></p>
                </div>
              </el-col>
            </el-row>
          </el-col>
          <el-col :xl="4" :lg="4" :md="8" :sm="8">
            <el-row :gutter="1" style="flex-direction: column;">
              <el-col :span="24">
                <div class="bg-White alignment top">
                  <p>خصم التاجر</p>
                  <p>
                    <span class="num">500ج.م</span>
                  </p>
                </div>
              </el-col>
              <el-col :span="24">
                <div class="bg-White alignment">
                  <p>خصم فاتورة</p>
                  <p><span class="num">1000ج.م</span></p>
                </div>
              </el-col>
            </el-row>
          </el-col>
          <el-col :xl="6" :lg="6" :md="8" :sm="8">
            <el-row :gutter="1" style="flex-direction: column;">
              <el-col :span="24">
                <div class="bg-White alignment top">
                  <p>سعر التسليم</p>
                  <p>
                    <span class="num">3873.75ج.م</span>
                  </p>
                </div>
              </el-col>
              <el-col :span="24">
                <div class="bg-White alignment">
                  <p>إجمالي المستحق</p>
                  <p><span class="num">3873.75ج.م</span></p>
                </div>
              </el-col>
            </el-row>
          </el-col>
          <el-col :xl="6" :lg="6" :md="8" :sm="8">
            <el-row :gutter="1" style="flex-direction: column;">
              <el-col :span="24">
                <div class="bg-White alignment top">
                  <p>قيمة المرتجع</p>
                  <p>
                    <span class="num">{{ reternSale.total_cost }}</span>
                  </p>
                </div>
              </el-col>
              <el-col :span="24">
                <div class="bg-White alignment">
                  <p>
                    <small>الإجمالي بعد المرتجع</small>
                  </p>
                  <p>
                    <span class="num">{{
                      sales[0].total_sale_cost -
                      sales[0].discount -
                      sales[0].returned_amount -
                      reternSale.total_cost
                    }}</span>
                  </p>
                </div>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
      </el-main>
    </el-container>
    <div v-if="confirmEdit == true" class="dialog">
      <div class="bodySec">
        <p @click="confirmEdit = false">
          <span><i class="far fa-times-circle"></i></span> اغلاق
        </p>
      </div>
      <div class="content">
        <div class="headerSection">
          <p>الرصيد السابق</p>
          <p class="mr-auto">
            {{
              numberToFixed(
                Number(sales[0].customer.balance) +
                  Number(sales[0].customer.account)
              )
            }}
          </p>
        </div>
        <div class="headerSection mt-2">
          <p>اجمالي الفاتوره</p>
          <p class="mr-auto">
            {{
              numberToFixed(
                Number(reternSale.total_cost) - Number(sales[0].discount)
              )
            }}
          </p>
        </div>
        <div class="headerSection mt-2">
          <p>اجمالي المدونية</p>
          <p class="mr-auto">
            {{
              numberToFixed(
                Number(sales[selectedIndex].customer.balance) -
                  (Number(reternSale.total_cost) - Number(sales[0].discount))
              ) + numberToFixed(Number(sales[selectedIndex].customer.account))
            }}
          </p>
        </div>
        <div class="mt-2">
          <el-checkbox v-model="reternSale.damaged_products"
            >البضاعه تالفه</el-checkbox
          >
        </div>
        <div class="mt-2">
          <el-radio-group
            v-model="setPaied"
            style="justify-content: start !important"
          >
            <el-radio-button label="without">حفظ بدون توريد</el-radio-button>
            <el-radio-button @click="alert" label="returnAmount"
              >توريد</el-radio-button
            >
          </el-radio-group>
        </div>
        <div v-if="setPaied == 'returnAmount'">
          <el-row>
            <el-col> <p class="label">قيمة المبلغ</p></el-col>
            <el-col>
              <input
                class="form-control"
                @focus="$event.target.select()"
                id="returnAmount"
                v-model="reternSale.returnAmount"
                @keyup.enter="editSale"
              />
            </el-col>
          </el-row>
        </div>
        <el-button
          class="mt-3 btn-green1 btn-save"
          @click="editSale"
          type="success"
          >حفظ الفاتورة</el-button
        >
        <el-button type="danger" @click="confirmEdit = false" class="exit mr-2"
          >الغاء</el-button
        >
      </div>
      <br />
    </div>
  </div>
</template>

<script>
import Aside from "@/components/aside.vue";
import axiosApi from "@/plugins/axios.js";

export default {
  components: { Aside },
  name: "ReturnProducts",
  data: () => ({
    true: true,
    damaged_products: false,
    selectAll: false,
    checkselectAll: false,
    disabled: false,
    isLoading: false,
    false: false,
    customer: null,
    product: null,
    productUnits: [],
    selectedUnit: null,
    sale_price: "",
    min_price: "",
    qty: "",
    active: "edit_sales",
    confirmSave: false,
    confirmEdit: false,
    totalInvoice: 0,
    timeout: null,
    selectedProductlastSaleCost: "-",
    selectedProductStock: "-",
    value: "",
    num: 1,
    ind: 0,
    selectedPorductIndex: 0,
    setPaied: "without",
    activeDelete: false,
    useParcode: false,
    autoPush: true,
    selectedIndex: 0,
    showPrice: false,
    percentageDiscount: 0,
    selectedUnitId: null,
    allowDeletePayment: false,
    showQtyToolTip: false,
    sales: [
      {
        inventory_id: 1,
        sale_id: "",
        paied: 0,
        returnAmount: 0,
        retuunt: 0,
        VAT: 0,
        customer: null,
        damaged_products: false,
        total_cost: 0,
        total_buy_cost: 0,
        total_sale_cost: 0,
        total_qty: 0,
        discount: 0,
        total_return_cost: 0,
        products: [],
      },
    ],
    reternSale: {
      inventory_id: 1,
      sale_id: "",
      customer: null,
      paied: 0,
      returnAmount: 0,
      damaged_products: false,
      total_cost: 0,
      total_qty: 0,
      total_discount: 0,
      percentage_discount: 0,
      products: [],
      total_buy_cost: 0,
      total_sale_cost: 0,
      discount: 0,
    },
  }),
  created() {
    if (localStorage.getItem("edited_sales")) {
      let sale_data = localStorage.getItem("edited_sales");
      this.sales = JSON.parse(sale_data);
      this.customer = this.sales[0].customer;
      this.calcTotal();
    } else {
      if (this.$route.params.id > 0) {
        this.getInvoice();
      }
    }
  },
  mounted() {
    // this.scrollToEnd();
  },
  watch: {
    setPaied: function (v) {
      this.reternSale.returnAmount = 0;
      if (v === "with") {
        setTimeout(() => {
          document.getElementById("paied").focus();
        }, 100);
      } else if (v === "returnAmount") {
        setTimeout(() => {
          document.getElementById("returnAmount").focus();
        }, 100);
      }
    },
  },
  methods: {
    alert() {
      alert("price clicked");
    },
    percentageDiscountChange() {
      this.reternSale.discount = Number(
        (Number(this.percentageDiscount) * this.reternSale.total_cost) / 100
      ).toFixed(2);
    },
    discountChange() {
      this.percentageDiscount = Number(
        (this.reternSale.discount / this.reternSale.total_cost) * 100
      ).toFixed(2);
    },
    goTo(routerName) {
      this.$router.push({ path: routerName });
    },
    getInvoice() {
      if (this.$route.params.id > 0) {
        axiosApi
          .get(`sales/${this.$route.params.id}`)
          .then((response) => {
            if (response.data.length > 0) {
              this.sales = response.data;
              this.customer = response.data[0].customer;
              this.sales[0].total_sale_cost = this.sales[0].total_cost;
              this.sales[0].discount = response.data[0].discount;
              this.sales[0].damaged_products = false;
              this.sales[0].total_return_cost = 0;
              this.sales[0].sale_id = this.$route.params.id;
              this.discountChange();
              let qty = 0;
              this.sales[0].products.map(function (value) {
                qty += value["pivot"]["qty"] - value["pivot"]["returned_qty"];
                value["pivot"]["old_qty"] = value["pivot"]["qty"];
                value["pivot"]["return_qty"] = 0;
                value["showQtyToolTip"] = false;
                value["checked"] = false;
              });
              this.sales[0].total_qty = qty;
              this.totalInvoice = this.sales[
                this.selectedIndex
              ].total_sale_cost;
            }
            this.checkStock();
          })
          .catch((e) => {
            console.log(e);
          });
      } else {
        console.log("من فضلك حدد رقم الفاتورة أولا للبحث");
      }
    },
    showPaymentModal() {
      this.confirmSave = true;
    },
    checkStock() {
      // edit-receipt/check-stock
      const loading = this.$loading({
        lock: true,
        text: "جاري تحميل البيانات",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      axiosApi
        .post(`edit-receipt/check-stock`, {
          products: this.sales[this.selectedIndex].products,
        })
        .then((res) => {
          loading.close();
          console.log("edit-receipt/check-stock", res.data);
          this.sales[this.selectedIndex].products = res.data;
          this.checkQty();
        })
        .catch(() => {
          loading.close();

          // this.$notify.error({
          //   title: "حدث خطأ",
          //   message: `عفوا المخزن المتاح لا يكفي `,
          //   duration: 1500,
          // });
        });
    },
    editSale() {
      if (!this.isLoading) {
        if (this.sales[this.selectedIndex].products.length > 0) {
          this.isLoading = true;
          const loading = this.$loading({
            lock: true,
            text: "جاري تحميل البيانات",
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.7)",
          });
          let products = [];
          for (let i = 0; i < this.sales[0].products.length; i++) {
            if (this.sales[0].products[i].pivot.return_qty > 0) {
              products.push({
                id: this.sales[0].products[i].id,
                name: this.sales[0].products[i].name,
                barcode: this.sales[0].products[i].barcode,
                units_per_package: this.sales[0].products[i].units_per_package,
                unit: this.sales[0].products[i].pivot.unit,
                units: this.sales[0].products[i].pivot.units,
                unit_type: this.sales[0].products[i].pivot.unit_type,
                sale_price: this.sales[0].products[i].pivot.sale_price,
                min_price: this.sales[0].products[i].pivot.min_price,
                buy_cost: this.sales[0].products[i].pivot.buy_cost,
                lastSaleCost: this.sales[0].products[i].pivot.lastSaleCost,
                old_qty: Number(this.sales[0].products[i].pivot.qty),
                qty: Number(this.sales[0].products[i].pivot.return_qty),
                total_discount: this.reternSale.discount,
                showQtyToolTip: false,
                showPriceToolTip: false,
                inventory_id: JSON.parse(
                  localStorage.getItem("user_inventories")
                )[0].id,
              });
            }
          }
          this.reternSale = {
            ...this.reternSale,
            inventory_id: this.sales[0].inventory_id,
            sale_id: this.sales[0].sale_id,
            customer: this.sales[0].customer,
            VAT: this.sales[0].VAT,
            percentage_discount: this.percentageDiscount,
            products: [...products],
            discount: this.sales[0].discount,
            total_discount: this.sales[0].discount,
          };
          this.reternSale.products = [...products];
          axiosApi
            .post(`sales/return`, this.reternSale)
            .then((response) => {
              this.invoice_details = response.data.invoice_details;
              this.$notify({
                title: "تمت العملية بنجاح",
                message: "تم حفظ بيانات الفاتورة بنجاح",
                type: "success",
                duration: 1500,
              });
              setTimeout(() => {
                this.$router.push("/sales/return");
              }, 100);
              console.log(response);
            })
            .catch((err) => {
              if (err.response.status == 403) {
                this.$notify.error({
                  title: "حدث خطأ",
                  message: "عفوا تأكد من كمية المرتجع",
                  duration: 1500,
                });
                for (let i = 0; i < this.sales[0].products.length; i++) {
                  this.sales[0].products[i].pivot.qty =
                    err.response.data[0].products[i].pivot.qty;
                  this.sales[0].products[i].pivot.returned_qty =
                    err.response.data[0].products[i].pivot.returned_qty;
                }
                this.confirmEdit = false;
              }
              console.log(err.response);
            })
            .finally(() => {
              loading.close();
              this.isLoading = false;
            });
        }
      }
    },
    calcTotal() {
      this.reternSale.total_cost = 0;
      this.reternSale.total_qty = 0;
      for (var i = 0; i < this.sales[0].products.length; i++) {
        if (
          Number(this.sales[0].products[i].pivot.return_qty) >
          this.sales[0].products[i].pivot.qty -
            this.sales[0].products[i].pivot.returned_qty
        ) {
          this.sales[0].products[i].showQtyToolTip = true;
        } else {
          this.sales[0].products[i].showQtyToolTip = false;
        }

        if (Number(this.sales[0].products[i].pivot.return_qty) > 0) {
          this.sales[0].products[i].checked = true;
        } else {
          this.sales[0].products[i].checked = false;
        }
        let returnTotal = Number(
          this.sales[0].products[i].pivot.return_qty *
            this.sales[0].products[i].pivot.sale_price
        );
        this.reternSale.total_qty += Number(
          this.sales[0].products[i].pivot.return_qty
        );
        this.reternSale.total_cost += Number(returnTotal);
      }
    },
    checkQty() {
      for (var i = 0; i < this.sales[0].products.length; i++) {
        this.sales[0].products[i].pivot.qty = Number(
          this.sales[0].products[i].pivot.qty
        );
        let qty = 0;
        if (
          Number(this.sales[0].products[i].pivot.qty) >=
          Number(this.sales[0].products[i].pivot.old_qty)
        ) {
          qty =
            Number(this.sales[0].products[i].pivot.qty) -
            Number(this.sales[0].products[i].pivot.old_qty);
        }
        if (qty > Number(this.sales[0].products[i].stock)) {
          this.disabled = true;
          return 1;
        } else {
          this.disabled = false;
        }
        if (this.sales[0].products[i].pivot.qty == "") {
          this.sales[0].products[i].pivot.qty = 1;
        }
      }
    },
    setLocalStorage() {
      localStorage.setItem("return_sales", JSON.stringify(this.sales));
    },
    numberToFixed(number) {
      return Math.floor(number * 100) / 100;
    },
    scrollToEnd() {
      setTimeout(() => {
        let elementToScrollDown = this.$refs.products_table;
        elementToScrollDown.scrollTop = elementToScrollDown.scrollHeight;
      }, 300);
      console.log("scrollToEnd");
    },
    saveShortKey() {
      if (this.confirmEdit) {
        this.editSale();
      }
    },
    selectProduct(row) {
      if (row.pivot.return_qty < row.pivot.qty - row.pivot.returned_qty) {
        row.pivot.return_qty = row.pivot.qty - row.pivot.returned_qty;
        row.checked = true;
      } else {
        row.pivot.return_qty = 0;
        row.checked = false;
      }
      this.calcTotal();
    },
    selectAllProducts() {
      document.getElementById("selectAll").click();
    },
    checkedAllProducts() {
      this.selectAll = !this.selectAll;
      if (this.selectAll == true) {
        this.sales[0].products.map((product) => {
          product.pivot.return_qty =
            product.pivot.qty - product.pivot.returned_qty;
        });
      } else {
        this.sales[0].products.map((product) => {
          product.pivot.return_qty = 0;
        });
      }
      this.calcTotal();
    },
  },
};
</script>

<style scoped>
#scrollToMe {
  overflow-y: scroll;
}
.text-center {
  text-align: center !important;
}
.el-table {
  width: 100%;
  min-height: 67%;
  max-height: 67%;
  overflow-y: scroll;
}
.form-control {
  height: 40px !important;
}
.el-main .footer .bg-White p {
  margin: 0;
}
.footer-top {
  background-color: #fcfbff;
  border-radius: 5px 5px 0 0;
  font-weight: bold;
  height: 8vh !important;
  margin-top: 10px;
}
.footer-top span {
  color: mediumblue;
  font-weight: bold;
  margin-right: 10px;
}
.alignment {
  justify-content: space-between !important;
  padding: 0 10px;
  height: 7vh !important;
  margin-top: 1px;
  border-radius: 0 0 5px 5px;
}
.top {
  border-radius: 0;
}
</style>
<style>
.el-popover--plain {
  padding: 11px 14px !important;
  background-color: #dc3545 !important;
  color: #fff !important;
}
</style>
